var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllPageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2984 4.28868C12.6913 3.9005 13.3244 3.90428 13.7126 4.29713C14.1008 4.68998 14.097 5.32313 13.7042 5.71132L6.32792 13H24.0032C24.5555 13 25.0032 13.4477 25.0032 14C25.0032 14.5523 24.5555 15 24.0032 15H6.3302L13.7042 22.2864C14.097 22.6746 14.1008 23.3078 13.7126 23.7006C13.3244 24.0935 12.6913 24.0972 12.2984 23.7091L3.37141 14.888C2.8762 14.3987 2.8762 13.5991 3.37141 13.1097L12.2984 4.28868Z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPageArrow);
export default __webpack_public_path__ + "static/media/All Page Arrow.9da5f0cd1804602e2ba7e568fe096f39.svg";
export { ForwardRef as ReactComponent };